/**
 * پیش‌شماره ۶ رقمی اول کارت بانکی (BIN) برای تشخیص بانک
 * منبع: استاندارد کارت‌های بانکی ایران
 */
const CARD_BIN_TO_BANK_NAME: Record<string, string> = {
  '603799': 'بانک ملی ایران',
  '603769': 'بانک صادرات',
  '610433': 'بانک ملت',
  '627353': 'بانک تجارت',
  '589210': 'بانک سپه',
  '628023': 'بانک مسکن',
  '627760': 'پست بانک ایران',
  '603770': 'بانک کشاورزی',
  '589463': 'بانک رفاه کارگران',
  '621986': 'بانک سامان',
  '502229': 'بانک پاسارگاد',
  '627648': 'بانک توسعه صادرات',
  '502806': 'بانک شهر',
  '502938': 'بانک دی',
  '627961': 'بانک صنعت و معدن',
  '627412': 'بانک اقتصاد نوین',
  '622106': 'بانک پارسیان',
  '627488': 'بانک کارآفرینی',
  '505416': 'بانک گردشگری',
  '505785': 'بانک ایران زمین',
  '505809': 'بانک خاورمیانه',
  '627381': 'بانک انصار',
  '606373': 'بانک مهر اقتصاد',
  '639370': 'بانک قرض‌الحسنه مهر',
  '636214': 'بانک آینده',
  '639346': 'بانک سینا',
  '639607': 'بانک سرمایه',
  '639599': 'بانک قوامین',
  '636949': 'بانک تات',
  '627963': 'بانک حکمت ایرانیان',
};

/**
 * از روی ۶ رقم اول شماره کارت، نام بانک را برمی‌گرداند (در صورت وجود در جدول BIN).
 */
export function getBankNameFromCardNumber(cardNumber: string): string | null {
  const digits = cardNumber.replace(/\D/g, '').slice(0, 6);
  if (digits.length < 6) return null;
  return CARD_BIN_TO_BANK_NAME[digits] ?? null;
}

/**
 * از بین لیست بانک‌های اپ، بانکی که با نام تشخیص‌داده‌شده از BIN همخوانی دارد پیدا می‌کند.
 */
export function findBankIdByCardNumber(
  cardNumber: string,
  banks: { id: number; name: string }[]
): number | null {
  const detectedName = getBankNameFromCardNumber(cardNumber);
  if (!detectedName || banks.length === 0) return null;
  const normalizedDetected = detectedName.replace(/\s/g, '').replace(/بانک\s*/g, '');
  for (const b of banks) {
    const normalizedBank = b.name.replace(/\s/g, '').replace(/بانک\s*/g, '');
    if (
      normalizedBank.includes(normalizedDetected) ||
      normalizedDetected.includes(normalizedBank) ||
      b.name === detectedName
    ) {
      return b.id;
    }
  }
  return null;
}
